import MuiSlider, {
  type SliderProps as MuiSliderProps,
} from '@mui/material/Slider';
import { styles } from './utils';

export interface SliderProps extends Omit<
  MuiSliderProps,
  'sx' | 'style' | 'onChange'
> {
  className?: string;
  style?: MuiSliderProps['sx'];
  thumbSize?: number;
  onChange: (value: number) => void;
}

export default function Slider({
  className,
  style = {},
  marks = false,
  defaultValue = 0,
  min = 0,
  step = 1,
  thumbSize = 24,
  valueLabelDisplay = 'auto',
  onChange,
  ...props
}: SliderProps) {
  const handleChange: MuiSliderProps['onChange'] = (e, i) => {
    // It'll never be an array, but MuiSlider types it as number[] | number
    return onChange(Array.isArray(i) ? i[0] : i);
  };

  return (
    <MuiSlider
      sx={{ ...styles.slider(thumbSize), ...style }}
      className={className}
      marks={marks}
      valueLabelDisplay={valueLabelDisplay}
      defaultValue={defaultValue}
      min={min}
      step={step}
      onChange={handleChange}
      {...props}
    />
  );
}
